import { IceCreamCone } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

export function AuthLayout({ title, subtitle, children, footer }: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-gradient-to-b from-accent/60 to-background px-4 py-10">
      <Link to="/" className="mb-6 flex items-center gap-2 font-semibold">
        <span className="flex size-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
          <IceCreamCone className="size-5" />
        </span>
        Gestión Locales
      </Link>
      <div className="w-full max-w-sm rounded-2xl border bg-card p-6 shadow-sm">
        <h1 className="text-xl font-semibold">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
      {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
    </div>
  );
}
